import React from 'react';

export const DashboardScheduleIcon = (props) => {
  const { className = '', style = {} } = props;
  return (
    <svg
      className={className}
      style={style}
      width="24"
      height="24"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.73882 9.53369H6.52743C6.67729 9.53369 6.79878 9.65518 6.79878 9.80504V10.5937C6.79878 10.7435 6.67729 10.865 6.52743 10.865H5.73882C5.58896 10.865 5.46747 10.7435 5.46747 10.5937V9.80504C5.46747 9.65518 5.58896 9.53369 5.73882 9.53369Z"
        fill="#113E57"
      />
      <path
        d="M6.52743 11.4761H5.73882C5.58896 11.4761 5.46747 11.5976 5.46747 11.7474V12.536C5.46747 12.6859 5.58896 12.8074 5.73882 12.8074H6.52743C6.67729 12.8074 6.79878 12.6859 6.79878 12.536V11.7474C6.79878 11.5976 6.67729 11.4761 6.52743 11.4761Z"
        fill="#113E57"
      />
      <path
        d="M5.73882 13.418H6.52743C6.67729 13.418 6.79878 13.5395 6.79878 13.6893V14.4779C6.79878 14.6278 6.67729 14.7493 6.52743 14.7493H5.73882C5.58896 14.7493 5.46747 14.6278 5.46747 14.4779V13.6893C5.46747 13.5395 5.58896 13.418 5.73882 13.418Z"
        fill="#113E57"
      />
      <path
        d="M8.46102 9.53369H7.67241C7.52255 9.53369 7.40106 9.65518 7.40106 9.80504V10.5937C7.40106 10.7435 7.52255 10.865 7.67241 10.865H8.46102C8.61089 10.865 8.73238 10.7435 8.73238 10.5937V9.80504C8.73238 9.65518 8.61089 9.53369 8.46102 9.53369Z"
        fill="#113E57"
      />
      <path
        d="M7.67241 11.4761H8.46102C8.61089 11.4761 8.73238 11.5976 8.73238 11.7474V12.536C8.73238 12.6859 8.61089 12.8074 8.46102 12.8074H7.67241C7.52255 12.8074 7.40106 12.6859 7.40106 12.536V11.7474C7.40106 11.5976 7.52255 11.4761 7.67241 11.4761Z"
        fill="#113E57"
      />
      <path
        d="M8.46102 13.418H7.67241C7.52255 13.418 7.40106 13.5395 7.40106 13.6893V14.4779C7.40106 14.6278 7.52255 14.7493 7.67241 14.7493H8.46102C8.61089 14.7493 8.73238 14.6278 8.73238 14.4779V13.6893C8.73238 13.5395 8.61089 13.418 8.46102 13.418Z"
        fill="#113E57"
      />
      <path
        d="M9.59722 9.53369H10.3858C10.5357 9.53369 10.6572 9.65518 10.6572 9.80504V10.5937C10.6572 10.7435 10.5357 10.865 10.3858 10.865H9.59722C9.44735 10.865 9.32587 10.7435 9.32587 10.5937V9.80504C9.32587 9.65518 9.44735 9.53369 9.59722 9.53369Z"
        fill="#113E57"
      />
      <path
        d="M10.3858 11.4761H9.59722C9.44735 11.4761 9.32587 11.5976 9.32587 11.7474V12.536C9.32587 12.6859 9.44735 12.8074 9.59722 12.8074H10.3858C10.5357 12.8074 10.6572 12.6859 10.6572 12.536V11.7474C10.6572 11.5976 10.5357 11.4761 10.3858 11.4761Z"
        fill="#113E57"
      />
      <path
        d="M9.59722 13.418H10.3858C10.5357 13.418 10.6572 13.5395 10.6572 13.6893V14.4779C10.6572 14.6278 10.5357 14.7493 10.3858 14.7493H9.59722C9.44735 14.7493 9.32587 14.6278 9.32587 14.4779V13.6893C9.32587 13.5395 9.44735 13.418 9.59722 13.418Z"
        fill="#113E57"
      />
      <path
        d="M12.3106 9.53369H11.522C11.3722 9.53369 11.2507 9.65518 11.2507 9.80504V10.5937C11.2507 10.7435 11.3722 10.865 11.522 10.865H12.3106C12.4605 10.865 12.582 10.7435 12.582 10.5937V9.80504C12.582 9.65518 12.4605 9.53369 12.3106 9.53369Z"
        fill="#113E57"
      />
      <path
        d="M11.522 11.4761H12.3106C12.4605 11.4761 12.582 11.5976 12.582 11.7474V12.536C12.582 12.6859 12.4605 12.8074 12.3106 12.8074H11.522C11.3722 12.8074 11.2507 12.6859 11.2507 12.536V11.7474C11.2507 11.5976 11.3722 11.4761 11.522 11.4761Z"
        fill="#113E57"
      />
      <path
        d="M12.3106 13.418H11.522C11.3722 13.418 11.2507 13.5395 11.2507 13.6893V14.4779C11.2507 14.6278 11.3722 14.7493 11.522 14.7493H12.3106C12.4605 14.7493 12.582 14.6278 12.582 14.4779V13.6893C12.582 13.5395 12.4605 13.418 12.3106 13.418Z"
        fill="#113E57"
      />
      <path
        d="M13.4556 9.53369H14.2442C14.3941 9.53369 14.5156 9.65518 14.5156 9.80504V10.5937C14.5156 10.7435 14.3941 10.865 14.2442 10.865H13.4556C13.3058 10.865 13.1843 10.7435 13.1843 10.5937V9.80504C13.1843 9.65518 13.3058 9.53369 13.4556 9.53369Z"
        fill="#113E57"
      />
      <path
        d="M14.2442 11.4761H13.4556C13.3058 11.4761 13.1843 11.5976 13.1843 11.7474V12.536C13.1843 12.6859 13.3058 12.8074 13.4556 12.8074H14.2442C14.3941 12.8074 14.5156 12.6859 14.5156 12.536V11.7474C14.5156 11.5976 14.3941 11.4761 14.2442 11.4761Z"
        fill="#113E57"
      />
      <path
        d="M13.4556 13.418H14.2442C14.3941 13.418 14.5156 13.5395 14.5156 13.6893V14.4779C14.5156 14.6278 14.3941 14.7493 14.2442 14.7493H13.4556C13.3058 14.7493 13.1843 14.6278 13.1843 14.4779V13.6893C13.1843 13.5395 13.3058 13.418 13.4556 13.418Z"
        fill="#113E57"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4652 4.08161C15.8976 4.08161 16.2623 4.22576 16.5675 4.51407H16.5421C16.8474 4.80238 17 5.15005 17 5.55707V15.826C17 16.6994 16.2962 17.4032 15.4228 17.4032H4.56027C4.1278 17.4032 3.76317 17.2591 3.4579 16.9708C3.15263 16.6825 3 16.3348 3 15.9278V5.55707C3 5.15005 3.15263 4.80238 3.4579 4.51407C3.76317 4.22576 4.13628 4.08161 4.56027 4.08161H5.3404V3.37779C5.3404 2.94532 5.68807 2.59766 6.12053 2.59766C6.553 2.59766 6.90067 2.94532 6.90067 3.37779V4.08161H13.1248V3.37779C13.1248 2.94532 13.4724 2.59766 13.9049 2.59766C14.3374 2.59766 14.685 2.94532 14.685 3.37779V4.08161H15.4652ZM4.57723 15.9278H15.4652V8.52497H4.57723V15.9278ZM4.57723 7.04102H15.4652V5.55707H4.57723V7.04102Z"
        fill="#113E57"
      />
    </svg>
  );
};
